import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';
import type { Id } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const ResolvableServicePage_OneResolvableService_QueryDocument = graphql(
  `
    query ResolvableServicePage_OneResolvableService_Query($id: Id!) {
      findOneResolvableService(id: $id) {
        _id
        code
        label
        ...ResolvableServicePage_Tabs_ResolvableServiceBaseInterface_Fragment
        ...ServiceUsageCardCmp_ResolvableServiceBaseInterface_Fragment
      }
    }
  `,
);

export type ResolvableServicePage_OneResolvableService = ResultOf<
  typeof ResolvableServicePage_OneResolvableService_QueryDocument
>['findOneResolvableService'];

export const useFindOneResolvableServiceQuery = (
  id: Id = EMPTY_ID,
  enabled = !!id,
) =>
  useGraphQLQuery(
    ResolvableServicePage_OneResolvableService_QueryDocument,
    { id },
    { enabled },
  );
